"use client"

import * as React from "react"

import { useCurrentWorkspaceAccess } from "@/features/auth/hooks/use-current-workspace-access"

/**
 * When the active workspace is `SINGLE_BRANCH`, product UI hides branch switching
 * and workspace-level “multi branch” admin (routes and data stay unchanged).
 */
export function useShowMultiBranchWorkspaceUi(): boolean {
  const access = useCurrentWorkspaceAccess()

  return React.useMemo(() => {
    const structure = access?.workspace?.structureType
    if (structure === "SINGLE_BRANCH") return false
    return true
  }, [access])
}
